export default __webpack_public_path__ + "static/media/image04.772c4edf.jpg";